import React from 'react'
import CreatePageWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import PageForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './create.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class CreatePage extends React.Component {

    constructor() {
        super()
        this.createPageWorker = CreatePageWorker(this)
        this.state = this.createPageWorker.getDefaultState()
    }

    componentDidMount(){
        this.createPageWorker.loadJournals()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createPageWorker.isValid() && this.createPageWorker.createPage()
    }

    onCancel = () => this.props.history.push('/journal/pages')

    render() {
        return (
            <div className="create-page">
                {
                    this.state.loadingJournals && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/journal/pages">Pages</Link>
                    <div className="header">
                        <h4>Create Page</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <PageForm {...this.state} action="Add Page" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                </div>
            </div>
        )
    }
}

export default withRouter(CreatePage)